import swal from 'sweetalert';


const SweetAlert = (type, message) =>
{
    return swal(type?.toUpperCase(), message, type)
} 

export default SweetAlert;